/* Solve 8x8 linear system via Gaussian elimination */
const solve = (A, b) => {
  const n = b.length;
  const M = A.map((row, i) => [...row, b[i]]);
  for (let c = 0; c < n; c++) {
    let p = c;
    for (let r = c + 1; r < n; r++) if (Math.abs(M[r][c]) > Math.abs(M[p][c])) p = r;
    [M[c], M[p]] = [M[p], M[c]];
    const pv = M[c][c] || 1e-12;
    for (let r = 0; r < n; r++) {
      if (r === c) continue;
      const f = M[r][c] / pv;
      for (let k = c; k <= n; k++) M[r][k] -= f * M[c][k];
    }
  }
  return M.map((row, i) => row[n] / (row[i] || 1e-12));
};

/* Homography mapping a w×h rect (origin 0,0) onto 4 destination px points [tl,tr,br,bl] → CSS matrix3d */
export const quadToMatrix3d = (w, h, dst) => {
  const src = [[0, 0], [w, 0], [w, h], [0, h]];
  const A = [], b = [];
  src.forEach(([x, y], i) => {
    const [X, Y] = dst[i];
    A.push([x, y, 1, 0, 0, 0, -X * x, -X * y]); b.push(X);
    A.push([0, 0, 0, x, y, 1, -Y * x, -Y * y]); b.push(Y);
  });
  const [a, bb, c, d, e, f, g, hh] = solve(A, b);
  return `matrix3d(${a},${d},0,${g},${bb},${e},0,${hh},0,0,1,0,${c},${f},0,1)`;
};

/* Convert percentage quad to px + bounding box size for a given container */
export const projectQuad = (quad, cw, ch) => {
  const pts = quad.map(([px, py]) => [(px / 100) * cw, (py / 100) * ch]);
  const xs = pts.map(p => p[0]), ys = pts.map(p => p[1]);
  const w = Math.max(...xs) - Math.min(...xs);
  const h = Math.max(...ys) - Math.min(...ys);
  return { w, h, transform: quadToMatrix3d(w, h, pts) };
};
